"use strict";

import getNgModule from "getNgModule";
const ngModule = getNgModule(__filename);

ngModule.controller("obsPresentationPopinCtrl", function ($scope, obsUtils) {
    $scope.derniereAnnee = obsUtils.getDerniereAnneeDispo();
});


// WEBPACK FOOTER //
// ./src/apps/observatoire/ng/presentation/obsPresentationPopinCtrl.js